import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { IEditorPart } from "../processDefinition-viewModel";
import { formSelectorViewModel } from "../processForms/formSelector";
import  { BpmnEditorView } from "./bpmnEditor-view"
import { PersonnelMultiSelectorViewModel } from "src/erp/enterpriseAdministration/humanResource/personnel/personnelMultiSelector";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import moment from "moment";
import { getAsNumber } from "src/uicomponents/components/utilities";

class singleNotificationInfo{
    public personnelIds : string[];
    public notificationTitle : string;
    public notificationBody : string;
    public notificationType : string;
}

export class BpmnEditorViewModel extends ViewModel implements IEditorPart{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.title = 'WorkFlow';
    }
    GetDefaultView(): View <ViewModel> {
        return new BpmnEditorView();
    }
    public getTypeId(): string {
        return "VM-0A1DA6BD-C03E-45CD-8FC1-4C676DE783F5"
    }
    dispose() {
        
    }
    private _processId : string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set xml(v: string) { this._xml = v; } public get xml(): string { return this._xml;} private _xml: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set drawing(v: boolean) { 
        this._drawing = v; 
    } public get drawing(): boolean { return this._drawing;} private _drawing: boolean;
    
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    private _hasUnsavedChanges:boolean;

    
    private additionalInfo : Map<string,string>;
    private elementIds : Map<string,string>;
    private notifications : Map<string,singleNotificationInfo>;
    private _dataModel :string;

    hasUnsavedChanges(): boolean {
        return this._hasUnsavedChanges;
    }
    diagramChanges() {
        this._hasUnsavedChanges = true;
    }
    async loadByProcessId(processId: string) {
        try {
            this.isLoading = true;
            this._processId = processId;
            this.additionalInfo = new Map<string,string>();
            this.elementIds = new Map<string,string>();
            this.notifications = new Map<string,singleNotificationInfo>();
            this._hasUnsavedChanges = false;
            this.drawing = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetCurrentProcessFlowXml',{
                ProcessId: processId
            });
            this._dataModel = result.DataModel;

            this.xml = result.Bpmn2Xml;
            this.additionalInfo.clear();
            this.elementIds.clear();
            this.notifications.clear();

            result.AdditionalInfo.forEach(x=>{
                this.additionalInfo.set(x.Key,x.Value);
            });
            result.ElementIdMappings.forEach(x=>{
                this.elementIds.set(x.Key,x.Value);
            });
            result.Notifications.forEach(x=>{
                let notificationInfo = new singleNotificationInfo();
                notificationInfo.personnelIds = x.PersonnelIds;
                notificationInfo.notificationTitle = x.NotificationTitle;
                notificationInfo.notificationBody = x.NotificationBody;
                notificationInfo.notificationType = x.AlertType==0 ? "1" : x.AlertType.toString() ;
                this.notifications.set(x.Key,notificationInfo);
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async save(){
        try {
            this.isLoading = true;
            await this.updateXml();
            let additionalInfo = [];
            this.additionalInfo.forEach((v,k)=>{
                additionalInfo.push({
                    Key : k,
                    Value : v
                })
            });
            let elementIds = [];
            this.elementIds.forEach((v,k)=>{
                elementIds.push({
                    Key : k,
                    Value : v
                })
            });

            let notifications = [];
            this.notifications.forEach((v,k)=>{
                notifications.push({
                    Key : k,
                    PersonnelIds : v.personnelIds,
                    NotificationTitle : v.notificationTitle,
                    NotificationBody : v.notificationBody,
                    AlertType : parseInt(v.notificationType)
                })
            });

            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/UpdateProcessFlow',{
                ProcessId: this._processId,
                Bpmn2Xml : this.xml,
                AdditionalInfo : additionalInfo,
                ElementIdMappings : elementIds,
                Notifications : notifications
            });
            this._hasUnsavedChanges = false;
            this.messageBoxConfirmSuccess("Workflow Saved Successfully",'Save');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    showPopup(popup:IPopup,autoHide:boolean=true):Promise<any>{
        let result = new Promise<string>((resolve,reject)=>{
            popup.closePopup = x=>{
                if(autoHide==true)
                    this.isShowingPopup = false;
                resolve(x);
            };
            this.popup = popup;
            this.isShowingPopup = true;
        });
        return result;
    }
    // showSequenceFlow(id: any) {
    //     this.showScriptingPopup(id);
    // }
    // showScriptTask(id: any) {
    //     this.showScriptingPopup(id);
    // }

    // async showTwoPaneScriptTask(id:any){
    //     let popup = new TwoPanelScriptViewModel(this);
    //     popup.loadData(this.additionalInfo.get(id));
    //     let result = await this.showPopup(popup);
    //     if(result!==false){
    //         this.additionalInfo.set(id,result);
    //     }
    // }
    // async setElementId(id: any) {
    //     let popup = new SelectElementIdPopup(this);
    //     popup.text = this.elementIds.get(id);
    //     let result = await this.showPopup(popup);
    //     if(result!==false){
    //         this.elementIds.set(id,result);
    //     }
    // }
    // async setNotificationReceivers(id:any){
    //     let popup = new selectNotificationReceiver(this);
    //     popup.setCurrentInfo(this.notifications.get(id));
    //     popup.setDataModel(this._dataModel);
    //     let result = await this.showPopup(popup);
    //     if(result!==false){
    //         this.notifications.set(id,result);
    //     }
    // }
    // async showScriptingPopup(id:string){
    //     let scriptingViewModel = new ScriptViewModel(this);
    //     scriptingViewModel.text = this.additionalInfo.get(id);
    //     let result =await this.showPopup(scriptingViewModel);
    //     if(result!==false){
    //         this.additionalInfo.set(id,result);
    //     }
        
    // }
    // async showUserTask(id: any) {
    //     let formSelector = new selectForm(this,this._processId);
    //     formSelector.selectFormId(this.additionalInfo.get(id));
    //     let result = await this.showPopup(formSelector);
    //     if(result!==false){
    //         this.additionalInfo.set(id,result)
    //     }
    // }

    private getFireTimeEditor(id:any):FireTimeEditor{
        let popup = new FireTimeEditor(this);
        popup.loadData(this.additionalInfo.get(id));
        return popup;
    }
    private getTwoPaneScript(id:any):TwoPanelScriptViewModel{
        let popup = new TwoPanelScriptViewModel(this);
        popup.loadData(this.additionalInfo.get(id));
        return popup;
    }

    
    private setTwoPaneScriptResult(id:any,result:any){
        if(result!==false){
            this.additionalInfo.set(id,result);
        }
    }

    private setFireTimeEditorResult(id:any,result:any){
        if(result!==false){
            this.additionalInfo.set(id,result);
        }
    }
    private getElementIdForm(id:string):SelectElementIdPopup{
        let popup = new SelectElementIdPopup(this);
        popup.text = this.elementIds.get(id);
        return popup;
    }
    private setElementIsFormResult(id:string,result:any){
        if(result!==false){
            this.elementIds.set(id,result);
        }
    }
    private getNotificationForm(id:string):selectNotificationReceiver{
        let popup = new selectNotificationReceiver(this);
        popup.setCurrentInfo(this.notifications.get(id));
        popup.setDataModel(this._dataModel);
        return popup;
    }
    private setNotificationResult(id:string,result:any){
        if(result!==false){
            this.notifications.set(id,result);
        }
    }
    private getScriptTask(id:string):ScriptViewModel{
        let scriptingViewModel = new ScriptViewModel(this);
        scriptingViewModel.text = this.additionalInfo.get(id);
        return scriptingViewModel;
    }
    private setScriptTaskResult(id:string,result){
        if(result!==false){
            this.additionalInfo.set(id,result);
        }
    }
    private getFormSelector(id:any):selectForm{
        let formSelector = new selectForm(this,this._processId);
        formSelector.selectFormId(this.additionalInfo.get(id));
        return formSelector;
    }
    private setFormSelectorResult(id:any,result:any){
        if(result!==false){
            this.additionalInfo.set(id,result)
        }
    }

    async editUserTask(id:any){
        let idForm  = this.getElementIdForm(id);
        let formSelector = this.getFormSelector(id);
        let notification = this.getNotificationForm(id);
        let result = await this.showEditorPopup([idForm,formSelector,notification]);
        if(result===true){
            this.setElementIsFormResult(id,idForm.getResult());
            this.setFormSelectorResult(id,formSelector.getResult());
            this.setNotificationResult(id,notification.getResult());
        }
    }
    async editScriptTask(id:any){
        let idForm  = this.getElementIdForm(id);
        let script = this.getScriptTask(id);
        let result = await this.showEditorPopup([idForm,script]);
        if(result===true){
            this.setElementIsFormResult(id,idForm.getResult());
            this.setScriptTaskResult(id,script.getResult());
        }
    }
    async editSequenceFlow(id:any){
        let idForm  = this.getElementIdForm(id);
        let script = this.getScriptTask(id);
        let result = await this.showEditorPopup([idForm,script]);
        if(result===true){
            this.setElementIsFormResult(id,idForm.getResult());
            this.setScriptTaskResult(id,script.getResult());
        }
    }
    async editSendTask(id:any){
        let idForm  = this.getElementIdForm(id);
        let script = this.getScriptTask(id);
        let result = await this.showEditorPopup([idForm,script]);
        if(result===true){
            this.setElementIsFormResult(id,idForm.getResult());
            this.setScriptTaskResult(id,script.getResult());
        }
    }
    async editReceiveTask(id:any){
        let idForm  = this.getElementIdForm(id);
        let script = this.getTwoPaneScript(id);
        let result = await this.showEditorPopup([idForm,script]);
        if(result===true){
            this.setElementIsFormResult(id,idForm.getResult());
            this.setTwoPaneScriptResult(id,script.getResult());
        }
    }
    async editIntermediateTimerEvent(id: any) {
        let idForm  = this.getElementIdForm(id);
        let fireTimeEditor = this.getFireTimeEditor(id);
        let result = await this.showEditorPopup([idForm,fireTimeEditor]);
        if(result===true){
            this.setElementIsFormResult(id,idForm.getResult());
            this.setFireTimeEditorResult(id,fireTimeEditor.getResult());
        }
    }
    async editStartTimerEvent(id: any) {
        let idForm  = this.getElementIdForm(id);
        let fireTimeEditor = this.getFireTimeEditor(id);
        let result = await this.showEditorPopup([idForm,fireTimeEditor]);
        if(result===true){
            this.setElementIsFormResult(id,idForm.getResult());
            this.setFireTimeEditorResult(id,fireTimeEditor.getResult());
        }
    }
    
    async editDefault(id:any){
        let idForm  = this.getElementIdForm(id);
        let result = await this.showEditorPopup([idForm]);
        if(result===true){
            this.setElementIsFormResult(id,idForm.getResult());
        }
    }
    private async showEditorPopup(forms:IEditorPopupPart[]|ObservableArray<IEditorPopupPart>){
        let popup = new EditorPopup(this);
        popup.setParts(forms);
        let result = await this.showPopup(popup);
        return result;
    }
    async updateXml():Promise<any>{

    }
}

export class SelectElementIdPopup extends ViewModel implements IPopup,IEditorPopupPart{
    public getTypeId(): string {return 'settingId';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;
    
    closePopup(result?: any) {
    }

    getResult() {
        if(stringIsNullOrEmpty(this.text))
            return false;
        return this.text;
    }

    save(){
        this.closePopup(this.getResult());
    }
    cancel(){
        this.closePopup(false);
    }
    
}
export class ScriptViewModel extends ViewModel implements IPopup,IEditorPopupPart{
    public getTypeId(): string {return 'scripting';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    closePopup(result: any) {
    }

    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;

    save(){
        this.closePopup(this.getResult());
    }
    getResult() {
        return this.text ?? '';
    }
    cancel(){
        this.closePopup(false);
    }
}
export class FireTimeEditor extends ViewModel implements IPopup,IEditorPopupPart{
    public getTypeId(): string {return 'fire-time-editor';}
    public GetDefaultView(): View<ViewModel> {return null;}

    public set isExact(v: boolean) { 
        this._isExact = v; 
        if(v){
            this.isElapsed = false;
            this.isCron = false;
        }else{
            this.selectCronIfNoneSelected();
        }
    
    } public get isExact(): boolean { return this._isExact;} private _isExact: boolean;
    public set isElapsed(v: boolean) { 
        this._isElapsed = v; 
        if(v){
            this.isExact = false;
            this.isCron = false;
        }else{
            this.selectCronIfNoneSelected();
        }
     } public get isElapsed(): boolean { return this._isElapsed;} private _isElapsed: boolean;
    public set isCron(v: boolean) { 
        this._isCron = v;
        if(v){
            this.isExact = false;
            this.isElapsed = false;
        }else{
            this.selectCronIfNoneSelected();
        }
    } public get isCron(): boolean { return this._isCron;} private _isCron: boolean;
    public set exactTime(v: moment.Moment) { this._exactTime = v; } public get exactTime(): moment.Moment { return this._exactTime;} private _exactTime: moment.Moment;
    public set exactHour(v: number) { this._exactHour = getAsNumber(v); } public get exactHour(): number { return this._exactHour;} private _exactHour: number;
    public set exactMinute(v: number) { this._exactMinute = getAsNumber(v); } public get exactMinute(): number { return this._exactMinute;} private _exactMinute: number;
    
    public set delay(v: number) { this._delay = getAsNumber(v); } public get delay(): number { return this._delay;} private _delay: number;
    public set cronExpression(v: string) { this._cronExpression = v; } public get cronExpression(): string { return this._cronExpression;} private _cronExpression: string;
    
    clearAllSelections(){
        this.isExact = false;
        this.isElapsed = false;
        this.isCron = false;
    }

    selectCronIfNoneSelected(){
        if(this.isExact==false && this.isElapsed==false && this.isCron==false)
            this.isCron = true;
    }

    constructor(parent:ViewModel) {
        super(parent);
        this.isExact = false;
        this.isElapsed = false;
        this.isCron = true;
        this.exactTime = moment.utc();
        this.exactHour = 0;
        this.exactMinute =0;
        this.delay =0;

        this.cronExpression = "* * * * * ? *";
    }

    loadData(data:string){
        try{
            let x = JSON.parse(data);
            this.isExact = x.firetimeType == 1;
            this.isElapsed = x.firetimeType == 2;
            this.isCron = x.firetimeType == 3;
            if(this.isExact) {
                this.exactTime = moment.utc(x.exactTime);
                this.exactHour = this.exactTime.hour();
                this.exactMinute = this.exactTime.minute();
            }
            if(this.isElapsed) this.delay = x.delay;
            if(this.isCron) this.cronExpression = x.cron;
        }catch{

        }
    }

    closePopup(result: any) {
    }
    save(){
        let result = this.getResult();
        this.closePopup(result);
    }
    getResult() {
        let exactTime = null;
        if(this.isExact){
            exactTime = this.exactTime.clone().hour(this.exactHour).minute(this.exactMinute).second(0).millisecond(0);
        }
        let obj = {
            firetimeType : this.isExact ? 1 : this.isElapsed ? 2 : 3,
            exactTime : this.isExact ? exactTime : null,
            delay : this.isElapsed ? this.delay : null,
            cron : this.isCron ? this.cronExpression : null
        };
        let result = JSON.stringify(obj);
        return result;    }
    cancel(){
        this.closePopup(false);
    }
}
export class TwoPanelScriptViewModel extends ViewModel implements IPopup,IEditorPopupPart{
    public getTypeId(): string {return 'twopanelscript';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.script = '';
        this.predicate = '';
    }
    
    public set script(v: string) { this._script = v; } public get script(): string { return this._script;} private _script: string;
    public set predicate(v: string) { this._predicate = v; } public get predicate(): string { return this._predicate;} private _predicate: string;
    
    loadData(data:string){
        this.script = '';
        this.predicate = '';
        try{
            let x = JSON.parse(data);
            this.script = x.Script ?? '';
            this.predicate = x.PredicateScript ?? '';
        }catch{

        }
    }
    closePopup(result: any) {
    }

    save(){
        let result = this.getResult();
        this.closePopup(result);
    }
    getResult() {
        let obj = {
            Script : this.script ?? '',
            PredicateScript : this.predicate ?? ''
        };
        let result = JSON.stringify(obj);
        return result;
    }
    cancel(){
        this.closePopup(false);
    }
}

export class selectForm extends ViewModel implements IPopup,IEditorPopupPart{
    
    public getTypeId(): string {return 'formselector';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,processId:string) {
        super(parent);
        this.processId = processId;        
        this.formSelector = new formSelectorViewModel(this,this.processId)
    }

    selectFormId(arg0: string) {
        if(stringIsNullOrEmpty(arg0)==false)
            this.formSelector.selectById(arg0)
    }

    closePopup(result: any = null) {
    }

    private processId:string;
    public set formSelector(v: formSelectorViewModel) { this._formSelector = v; } public get formSelector(): formSelectorViewModel { return this._formSelector;} private _formSelector: formSelectorViewModel;
    getResult() {
        if(this.formSelector && this.formSelector.selectedItem){
            return this.formSelector.selectedItem.id;
        }
        return false;
    }
    confirm(){
        this.closePopup(this.getResult());
    }
    cancel(){
        this.closePopup(false);
    }
}

export class selectNotificationReceiver extends ViewModel implements IPopup,IEditorPopupPart{

    addToTitle(suggestion:suggestion){
        this.title = `${this.title.slice(0,this.titlePosition)}${suggestion.code}${this.title.slice(this.titlePosition)}`;
    }
    addToBody(suggestion:suggestion){
        this.body = `${this.body.slice(0,this.bodyPosition)}${suggestion.code}${this.body.slice(this.bodyPosition)}`;
    }
    private createSuggestion(name:string,code:string,handler:any):suggestion{
        let r = new suggestion(this);
        r.name = name;
        r.code = code;
        r.itemSelected = handler;
        return r;
    }
    setDataModel(dataModel: string) {
        if(stringIsNullOrEmpty(dataModel))
            return;
        else {
            try{

                let validTypes = ['string','integer','float','datetime','bool','boolean']
                let parsedModel = JSON.parse(dataModel)
                let suggestions = parsedModel.classes.filter(x=>x.isRoot==true).at(0)
                    .properties.filter(x=>validTypes.includes(x.datatype)).map(x=>x.name);
                this.titleSuggestions.update(...suggestions.map(x=>{
                    let r = new suggestion(this);
                    r.name = x;
                    r.code = `%%__${x}__%%`;
                    r.itemSelected = x=>this.addToTitle(x); 
                    return r;
                }));
                this.titleSuggestions.push(...[
                    this.createSuggestion('-Current Time-','%%__-CurrentTime-__%%',x=>this.addToTitle(x)),
                    this.createSuggestion('-Current Date-','%%__-CurrentDate-__%%',x=>this.addToTitle(x)),
                    this.createSuggestion('-Current Year-','%%__-CurrentYear-__%%',x=>this.addToTitle(x)),
                    this.createSuggestion('-Current Month No-','%%__-CurrentMonthNo-__%%',x=>this.addToTitle(x)),
                    this.createSuggestion('-Current Month Name-','%%__-CurrentMonthName-__%%',x=>this.addToTitle(x)),
                    this.createSuggestion('-Current Day-','%%__-CurrentDay-__%%',x=>this.addToTitle(x)),

                    this.createSuggestion('-Personnel Name-','%%__-PersonnelName-__%%',x=>this.addToTitle(x)),
                    this.createSuggestion('-Personnel LastName-','%%__-PersonnelLastName-__%%',x=>this.addToTitle(x)),
                    this.createSuggestion('-Personnel Code-','%%__-PersonnelCode-__%%',x=>this.addToTitle(x)),
                ]);
                this.bodySuggestions.update(...suggestions.map(x=>{
                    let r = new suggestion(this);
                    r.name = x;
                    r.code = `%%__${x}__%%`;
                    r.itemSelected = x=>this.addToBody(x);
                    return r;
                }));
                this.bodySuggestions.push(...[
                    this.createSuggestion('-Current Time-','%%__-CurrentTime-__%%',x=>this.addToBody(x)),
                    this.createSuggestion('-Current Date-','%%__-CurrentDate-__%%',x=>this.addToBody(x)),
                    this.createSuggestion('-Current Year-','%%__-CurrentYear-__%%',x=>this.addToBody(x)),
                    this.createSuggestion('-Current Month No-','%%__-CurrentMonthNo-__%%',x=>this.addToBody(x)),
                    this.createSuggestion('-Current Month Name-','%%__-CurrentMonthName-__%%',x=>this.addToBody(x)),
                    this.createSuggestion('-Current Day-','%%__-CurrentDay-__%%',x=>this.addToBody(x)),

                    this.createSuggestion('-Personnel Name-','%%__-PersonnelName-__%%',x=>this.addToBody(x)),
                    this.createSuggestion('-Personnel LastName-','%%__-PersonnelLastName-__%%',x=>this.addToBody(x)),
                    this.createSuggestion('-Personnel Code-','%%__-PersonnelCode-__%%',x=>this.addToBody(x)),
                ]);
            }catch{

            }
        }
    }
    public getTypeId(): string {return 'set-notification-receiver';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.title = "";
        this.body = "";
        this.bodySuggestions = ObservableArray.create<suggestion>();
        this.titleSuggestions = ObservableArray.create<suggestion>();
        this.personnelSelector = new PersonnelMultiSelectorViewModel(this);
        this.notificationTypeSelector = new notificationTypeSelector(this);
        this.bodyPosition =0;
        this.titlePosition =0;
    }
    public set personnelSelector(v: PersonnelMultiSelectorViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelMultiSelectorViewModel { return this._personnelSelector;} private _personnelSelector: PersonnelMultiSelectorViewModel;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set body(v: string) { this._body = v; } public get body(): string { return this._body;} private _body: string;
    public set notificationTypeSelector(v: notificationTypeSelector) { this._notificationTypeSelector = v; } public get notificationTypeSelector(): notificationTypeSelector { return this._notificationTypeSelector;} private _notificationTypeSelector: notificationTypeSelector;
    
    public set titleSuggestions(v: ObservableArray<suggestion>) { this._titleSuggestions = v; } public get titleSuggestions(): ObservableArray<suggestion> { return this._titleSuggestions;} private _titleSuggestions: ObservableArray<suggestion>;
    public set bodySuggestions(v: ObservableArray<suggestion>) { this._bodySuggestions = v; } public get bodySuggestions(): ObservableArray<suggestion> { return this._bodySuggestions;} private _bodySuggestions: ObservableArray<suggestion>;
    
    public set bodyPosition(v: number) { this._bodyPosition = v; } public get bodyPosition(): number { return this._bodyPosition;} private _bodyPosition: number;
    public set titlePosition(v: number) { this._titlePosition = v; } public get titlePosition(): number { return this._titlePosition;} private _titlePosition: number;
    
    closePopup(result: any) {
    }
    
    setCurrentInfo(arg0: singleNotificationInfo) {
        if(arg0==null)
            arg0 = new singleNotificationInfo();

        this.personnelSelector.selectById(arg0?.personnelIds ?? []);
        this.title = arg0?.notificationTitle ?? "";
        this.body = arg0?.notificationBody ?? "";
        this.notificationTypeSelector.selectById(arg0?.notificationType ?? "1")
    }
    
    confirm(){
        this.closePopup(this.getResult());
    }
    getResult():any{
        let result = new singleNotificationInfo();
        result.personnelIds = this.personnelSelector.selectedItems.map(x=>x.id);
        result.notificationTitle = this.title ?? '';
        result.notificationBody = this.body ?? '';
        result.notificationType = this.notificationTypeSelector.selectedItem?.id ?? "1";
        return result;
    }
    cancel(){
        this.closePopup(false);
    }
}
export class suggestion extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    onSelect(){
        this.itemSelected(this);
    }
    itemSelected(v:suggestion){

    }
}
export class notificationTypeSelector extends SelectorBaseViewModel<notificationType>{
    protected loadData(): Promise<notificationType[]> {
        return Promise.resolve<notificationType[]>([
            this.createType("1","Success"),
            this.createType("2","Info"),
            this.createType("3","Warning"),
            this.createType("4","Error")
        ]);
    }
    private createType(id:string,title:string):notificationType{
        let result = new notificationType(this);
        result.id = id;
        result.title = title;
        return result;
    }
}
export class notificationType extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
interface IEditorPopupPart{
    getResult():any;
}

export class EditorPopup extends ViewModel implements IPopup{
    public getTypeId(): string {return 'editor-popup';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.parts = ObservableArray.create<IEditorPopupPart>();    
    }

    closePopup(result: any) {
    }

    setParts(parts:IEditorPopupPart[]|ObservableArray<IEditorPopupPart>){
        this.parts.update(...parts);
    }
    public set parts(v: ObservableArray<IEditorPopupPart>) { this._parts = v; } public get parts(): ObservableArray<IEditorPopupPart> { return this._parts;} private _parts: ObservableArray<IEditorPopupPart>;
    
    confirm(){
        this.closePopup(true);
    }
    close(){
        this.closePopup(false);
    }
    
}
